export default [
  {
    label: "Allegory",
    value: "Allegory"
  },
  {
    label: "Ars poetica",
    value: "Ars poetica"
  },
  {
    label: "Aubade",
    value: "Aubade"
  },
  {
    label: "Bildungsroman/Coming-of-Age",
    value: "Bildungsroman / Coming-of-Age"
  },
  {
    label: "Blason",
    value: "Blason"
  },
  {
    label: "Cento",
    value: "Cento"
  },
  {
    label: "Colonial Literature",
    value: "Colonial Literature"
  },
  {
    label: "Comedy",
    value: "Comedy"
  },
  {
    label: "Comedy of Manners",
    value: "Comedy of Manners"
  },
  {
    label: "Crime/True Crime",
    value: "Crime / True Crime"
  },
  {
    label: "Dirge",
    value: "Dirge"
  },
  {
    label: "Dramatic monologue",
    value: "Dramatic monologue"
  },
  {
    label: "Dystopian",
    value: "Dystopian"
  },
  {
    label: "Eclogue",
    value: "Eclogue"
  },
  {
    label: "Ekphrasis",
    value: "Ekphrasis"
  },
  {
    label: "Elegy",
    value: "Elegy"
  },
  {
    label: "Epic",
    value: "Epic"
  },
  {
    label: "Epigram",
    value: "Epigram"
  },
  {
    label: "Epistolary",
    value: "Epistolary"
  },
  {
    label: "Epitaph",
    value: "Epitaph"
  },
  {
    label: "Epithalamion",
    value: "Epithalamion"
  },
  {
    label: "Fantasy",
    value: "Fantasy"
  },
  {
    label: "Farce",
    value: "Farce"
  },
  {
    label: "Georgic",
    value: "Georgic"
  },
  {
    label: "Gothic",
    value: "Gothic"
  },
  {
    label: "Historical Fiction",
    value: "Historical Fiction"
  },
  {
    label: "History Play/Historical Drama",
    value: "History Play / Historical Drama"
  },
  {
    label: "Horror",
    value: "Horror"
  },
  {
    label: "Hymn",
    value: "Hymn"
  },
  {
    label: "Idyll",
    value: "Idyll"
  },
  {
    label: "Kunstlerroman",
    value: "Kunstlerroman"
  },
  {
    label: "Lament",
    value: "Lament"
  },
  {
    label: "Light verse",
    value: "Light verse"
  },
  {
    label: "Mock-Epic",
    value: "Mock-Epic"
  },
  {
    label: "Morality or Mystery Play",
    value: "Morality or Mystery Play"
  },
  {
    label: "Mystery",
    value: "Mystery"
  },
  {
    label: "Nature/Environmental Writing",
    value: "Nature/Environmental Writing"
  },
  {
    label: "Novel of Ideas",
    value: "Novel of Ideas"
  },
  {
    label: "Novel of Manners",
    value: "Novel of Manners"
  },
  {
    label: "Ode",
    value: "Ode"
  },
  {
    label: "Other",
    value: "<n/a>"
  },
  {
    label: "Paean",
    value: "Paean"
  },
  {
    label: "Palinode",
    value: "Palinode"
  },
  {
    label: "Panegyric",
    value: "Panegyric"
  },
  {
    label: "Parody",
    value: "Parody"
  },
  {
    label: "Pastoral",
    value: "Pastoral"
  },
  {
    label: "Philosophical Fiction",
    value: "Philosophical Fiction"
  },
  {
    label: "Picaresque",
    value: "Picaresque"
  },
  {
    label: "Problem Play",
    value: "Problem Play"
  },
  {
    label: "Psalm",
    value: "Psalm"
  },
  {
    label: "Quest",
    value: "Quest"
  },
  {
    label: "Religious Fiction",
    value: "Religious Fiction"
  },
  {
    label: "Revenge Tragedy",
    value: "Revenge Tragedy"
  },
  {
    label: "Riddle",
    value: "Riddle"
  },
  {
    label: "Romance",
    value: "Romance"
  },
  {
    label: "Satire",
    value: "Satire"
  },
  {
    label: "Science Fiction",
    value: "Science Fiction"
  },
  {
    label: "Science Writing",
    value: "Science Writing"
  },
  {
    label: "Sensation Fiction",
    value: "Sensation Fiction"
  },
  {
    label: "Slave Narrative",
    value: "Slave Narrative"
  },
  {
    label: "Socratic Dialogue",
    value: "Socratic Dialogue"
  },
  {
    label: "Southern Gothic",
    value: "Southern Gothic"
  },
  {
    label: "Suspense/Thriller",
    value: "Suspense / Thriller"
  },
  {
    label: "Tragedy",
    value: "Tragedy"
  },
  {
    label: "Tragicomedy",
    value: "Tragicomedy"
  },
  {
    label: "Utopian",
    value: "Utopian"
  },
  {
    label: "Verse Epistle",
    value: "Verse Epistle"
  },
  {
    label: "Verse Novel",
    value: "Verse Novel"
  },
  {
    label: "Western/Frontier",
    value: "Western / Frontier"
  }
];
